import { useCallback, useContext } from "react";
import { monthLabels } from "./utils/constants";
import type { ICalendarContext } from "./types";
import { TimePeriod } from "./types";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CalendarContext } from "./context";
import { IconButton } from "../Button/IconButton";
import { Button } from "../Button/Button";

export const TimePeriodControl = () => {
  const {
    handleTimePeriodChange,
    dateForPeriod,
    onDateForPeriodChange,
    timePeriod,
  }: ICalendarContext = useContext(CalendarContext);

  const handleChangeMonth = useCallback(
    (delta: number) => () => {
      const nextDate: Date = new Date(dateForPeriod);

      let monthIndex: number = nextDate.getMonth() + delta;
      let year = nextDate.getFullYear();

      if (monthIndex < 0) {
        monthIndex = 11;
        year--;
      } else if (monthIndex > 11) {
        monthIndex = 0;
        year++;
      }

      nextDate.setMonth(monthIndex);
      nextDate.setFullYear(year);
      onDateForPeriodChange(nextDate);
    },
    [dateForPeriod, onDateForPeriodChange],
  );

  const onMonthViewClick = useCallback((): void => {
    handleTimePeriodChange(TimePeriod.Months);
  }, [handleTimePeriodChange]);

  const onYearsViewClick = useCallback((): void => {
    handleTimePeriodChange(TimePeriod.Years);
  }, [handleTimePeriodChange]);

  return (
    <div className="nuco-calendar__periodControl">
      <Button
        className="nuco-calendar__periodControlButton"
        variant="filled"
        color="layer2"
        content={monthLabels[dateForPeriod.getMonth()]}
        onClick={onMonthViewClick}
      />
      <Button
        className="nuco-calendar__periodControlButton"
        variant="filled"
        color="layer2"
        content={dateForPeriod.getFullYear()}
        onClick={onYearsViewClick}
      />

      {timePeriod === TimePeriod.Days && (
        <div className="nuco-calendar__monthButtons">
          <IconButton
            variant="filled"
            color="layer2"
            onClick={handleChangeMonth(-1)}
            content={<ChevronLeft size="1rem" />}
          />
          <IconButton
            variant="filled"
            color="layer2"
            onClick={handleChangeMonth(1)}
            content={<ChevronRight size="1rem" />}
          />
        </div>
      )}
    </div>
  );
};
